import LaptopAndPhone from '../src/LaptopAndPhone';
export default LaptopAndPhone;
